
export const SET_LOADING = "SET_LOADING";

export const SET_SEARCH_VALUE = "SET_SEARCH_VALUE";

export const TOGGLE_SHOW_INVITE_USER_DIALOG = "TOGGLE_SHOW_INVITE_USER_DIALOG";

export const TOGGLE_SHOW_EDIT_TENANT_DIALOG = "TOGGLE_SHOW_EDIT_TENANT_DIALOG";

export const TOGGLE_SHOW_ADD_APP_DIALOG = "TOGGLE_SHOW_ADD_APP_DIALOG";

export const TOGGLE_SHOW_DELETE_TENANT_APP_DIALOG = "TOGGLE_SHOW_DELETE_TENANT_APP_DIALOG";

export const TOGGLE_SHOW_NOTIFICATION = "TOGGLE_SHOW_NOTIFICATION";

export const SET_TENANTS = "SET_TENANTS";

export const SET_PROJECTS = "SET_PROJECTS";

export const ADD_TENANT = "ADD_TENANT";

export const ADD_TENANT_APP = "ADD_TENANT_APP";

export const UPDATE_TENANT = "UPDATE_TENANT";

export const UPDATE_TENANT_APP = "UPDATE_TENANT_APP";

export const DELETE_TENANT_APP = "DELETE_TENANT_APP";

export const SET_SELECTED_TENANT_ID = "SET_SELECTED_TENANT_ID";

export const SET_SELECTED_MASTER_PROJECT_ID = "SET_SELECTED_MASTER_PROJECT_ID";

export const SET_NOTIFICATION_MESSAGE = "SET_NOTIFICATION_MESSAGE";

export const SET_NOTIFICATION_TYPE = "SET_NOTIFICATION_TYPE";
